




import { Component, Vue } from "vue-property-decorator";

@Component
export default class Delete extends Vue {
  private async created() {
    localStorage.clear();
    await this.$router.push({
      name: "Survey",
      query: this.$route.query
    });
  }
}
